module.exports = __webpack_public_path__ + "static/media/class3.39acf756.jpg";